import GameCore from "../GameCore";
import CoinCounterGroup from "./CoinCounterGroup";
import Game from "../Game";
import { GAME_FONTS } from "../../../utils/FontManager";

export default class CoinCounter extends Phaser.GameObjects.Text {
  pool: CoinCounterGroup;
  tween1: Phaser.Tweens.Tween;
  tween2: Phaser.Tweens.Tween;
  coinCount: number;

  constructor(group: CoinCounterGroup, x: number, y: number) {
    super(group.scene, x, y, "", {
      fontFamily: GAME_FONTS.PIXEL,
      fontSize: "16px",
      color: "#FFD700",
      stroke: "#000000",
      strokeThickness: 3,
    });

    this.pool = group;
    this.scene.add.existing(this);
    this.coinCount = 0;
  }

  Init() {
    this.setDepth(GameCore.ZDamageNumber);
    this.setOrigin(0.5, 1);
  }

  OnRecycle(x: number, y: number, count: number) {
    // Make visible
    this.visible = true;
    this.setAlpha(1);

    // Store the coin count for this counter
    this.coinCount = count;

    // Scale based on consecutive count (bigger for higher counts)
    const baseScale = GameCore.PixelScale;
    const scaleMultiplier = Math.min(1 + count * 0.2, 10); // Cap at 10x size
    this.setScale(baseScale * scaleMultiplier);

    // Position slightly above the pickup
    this.setPosition(x, y - 16);

    // Set text to +count
    this.setText(`+${count}`);

    // Color gets more golden/brighter with higher counts
    if (count >= 100) {
      this.setColor("#FFFF00"); // Bright yellow for 5+
    } else if (count >= 30) {
      this.setColor("#FFE066"); // Light gold for 3-4
    } else {
      this.setColor("#FFD700"); // Regular gold for 1-2
    }

    // Stop any existing tweens
    if (this.tween1) {
      this.tween1.stop();
    }
    if (this.tween2) {
      this.tween2.stop();
    }

    // Create fade out tween (paused initially)
    this.tween2 = this.scene.tweens.add({
      targets: this,
      alpha: 0,
      scale: baseScale * scaleMultiplier,
      // Use a logarithmic scale for duration to prevent extremely long animations
      duration: Math.min(400 + Math.log(count + 1) * 200, 4000), // Cap at 2 seconds
      paused: true,
      onComplete: () => {
        this.DeSpawn();
      },
    });

    // Create pop-up tween
    this.tween1 = this.scene.tweens.add({
      targets: this,
      y: this.y - (20 + Math.min(count, 30) * 2), // Cap the vertical movement
      scale: baseScale * scaleMultiplier * 1.2,
      // Also use logarithmic scaling for the pop-up duration
      duration: Math.min(200 + Math.log(count + 1) * 100, 2000), // Cap at 1 second
      onComplete: () => {
        this.tween2.play();
      },
    });
  }

  DeSpawn() {
    this.visible = false;
    this.pool.Return(this);
  }
}
